import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLink, PageTitle } from '../../layout/core';
import { DisputesList } from '../../components/disputes/all_disputes/DisputesList';
import { PageContextProvider } from '../../store/page-context';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';

const matchedDisputesBreadCrumbs: Array<PageLink> = [
	{
		title: 'MENU.DISPUTES',
		path: '/disputes/all',
		isSeparator: false,
		isActive: false
	},
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];

export const DisputesPage: FC = () => {
	const { t } = useTranslation();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	return (
		<PageContextProvider page="disputes/all">
			<>
				{/*TODO check partners permissions*/}
				<PageTitle breadcrumbs={checkRoles(authUser, CLAIMS.PARTNER_ADMIN) || checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN) ? [] : matchedDisputesBreadCrumbs}>
					{checkRoles(authUser, CLAIMS.PARTNER_ADMIN) || checkRoles(authUser, CLAIMS.INTEGRATION_PARTNER_ADMIN) ? t('MENU.DISPUTES') : t('MENU.ALL')}
				</PageTitle>
				<DisputesList/>
			</>
		</PageContextProvider>
	);
};
